module.exports = require('./compiled/jwt-token-encrypt');
